import { render, staticRenderFns } from "./ConcentrationsDropdown.vue?vue&type=template&id=425f45a6&scoped=true"
import script from "./ConcentrationsDropdown.vue?vue&type=script&lang=js"
export * from "./ConcentrationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ConcentrationsDropdown.vue?vue&type=style&index=0&id=425f45a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f45a6",
  null
  
)

export default component.exports